import { colors } from 'themes/colors';
import { breakpoints } from 'themes/breakpoints';

export const theme = {
  colors,
  breakpoints
}